import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import {Stack, Typography} from '@customink/pigment-react';
import {styled} from '@customink/pigment-react/lib/themeCustomink';
import PropTypes from 'prop-types';
import React from 'react';
import ProductHeaderBadge from './ProductHeaderBadge';
import {BADGE_NAME_MAP} from './useProductBadges';

const Text = styled(Typography)({
  fontSize: '13px',
  lineHeight: '16px'
});

export default function ProductHeaderBadges({badges, categoryName}) {
  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="center"
      alignItems="center"
      marginBottom={{md: '0.25rem', sm: '0'}}>
      <ProductHeaderBadge title={BADGE_NAME_MAP[badges[0]]} />
      <Stack direction="row" spacing="0.5rem" alignItems="center">
        <Text
          data-testid="product-header-badge-in-category"
          color={designTokens.color.gray.slateDefault.value}>
          in {categoryName}
        </Text>
      </Stack>
    </Stack>
  );
}

ProductHeaderBadges.propTypes = {
  badges: PropTypes.arrayOf(PropTypes.string).isRequired,
  categoryName: PropTypes.string.isRequired
};
